import { useEffect, useState } from 'react'

const levels = ['browning', 'cooking']

export default ({ fetchLabelLevels, fetchLocales }) => {

  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    (async () => {
      if (!loaded) {
        const locales = await fetchLocales()
        if (locales) {
          try {
            await fetchLabelLevels('browning', locales[0].id)
          } catch(e) {
            //ignore exception
          }
          try {
            await fetchLabelLevels('cooking', locales[0].id)
          } catch(e) {
            //ignore exception
          }
        }
        setLoaded(true)
      }
    })()
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  return {
    levels,
    loaded,
  }
}
